import { CardComp } from "../../../components";
import FineSettingComp from "./modules/FineSettingComp";
import { useNavigate } from "react-router-dom";

export default function FineSettings() {
  const navigate = useNavigate();

  const TableDropDown = (row) => [
    {
      name: row.isNew ? "Configure" : "Edit",
      action: (data) => {
        if (data.isNew) {
          navigate(`new?category_id=${data.fine_category_id}&category_name=${data.category_name}`);
        } else {
          // Navigate to edit page with fine ID
          navigate(`edit/${data.id}`);
        }
      },
    },
  ];

  return (
    <section className="px-2 px-lg-4 min-vh-100 rounded-4">
      <CardComp cardBodyClassName={"py-0"} cardClassName={"pt-4 mb-4"}>
        <h4 className=" text-black1 fw-bold">Fine Settings</h4>
        <p className="text-muted small">Configure the amount for each fine category. Only one amount can be set per category.</p>
      </CardComp>
      
      <FineSettingComp
        TableDropDown={TableDropDown}
        onSubmit={() => navigate("new")}
        emptyTable="No fine categories found"
      />
    </section>
  );
}
